import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const FLAGS = {
  "es-ES": "🇪🇸",
  "ca-ES": "https://upload.wikimedia.org/wikipedia/commons/c/ce/Flag_of_Catalonia.svg",
  "en": "🇬🇧",
};

export const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language || "es-ES";
  const flag = FLAGS[currentLang] || FLAGS["es-ES"];
  const isEmoji = typeof flag === "string" && !flag.startsWith("http");

  return (
    <Link
      to="/language"
      className="btn btn-sm rounded-circle d-flex align-items-center justify-content-center border-0 text-decoration-none"
      title={t("Cambiar idioma")}
      style={{
        width: "36px",
        height: "36px",
        cursor: "pointer",
        fontSize: "1.1rem",
      }}
      aria-label={t("Cambiar idioma")}
    >
      {isEmoji ? (
        <span style={{ fontSize: "1.2rem", lineHeight: 1 }}>{flag}</span>
      ) : (
        <img
          src={flag}
          alt={currentLang}
          style={{
            width: "24px",
            height: "18px",
            objectFit: "cover",
            borderRadius: "3px",
          }}
        />
      )}
    </Link>
  );
};
